import { Box } from "@mui/material";
import { WizardProps, formatReportData, formatLocationsText } from "models/wizard/wizard-modals";
import React, { useEffect } from "react";
import { MdCheck } from "react-icons/md";

const WizardReport: React.FC<WizardProps> = ({
  userReport,
  duration,
  durationType,
  complaintRemark,
  impressionRemark,
  examinationRemark,
  treatmentRemark,
  subComplaintRemark,
  data,
  setReport,
  setComplaintRemark,
  // setSubComplaintRemark,
  setImpressionRemark,
  setExaminationRemark,
  setTreatmentRemark,
  setData,
  page,
  setPage,
  otherSymptomRemark,
  otherSymptomDuration,
  otherSymptomDurationType,
  setOtherSymptomRemark,
  setOtherSymptomDuration,
  setOtherSymptomDurationType,
  historyRemark,
  historyDuration,
  historyDurationType,
  setHistoryRemark,
  setHistoryDuration,
  setHistoryDurationType,
  setDuration,
  setDurationType,
  resetSelectedOptions,
  resetTrigger,
  setResetTrigger,

  setComplaintLocation,
  complaintLocation,
  setOtherSymptomLocation,
  otherSymptomLocation,
  examinationLocation,
  setExaminationLocation,
  impressionLocation,
  setImpressionLocation,
}) => {
  const [textCopied, setTextCopied] = React.useState(false);

  const handleCopyToClipboard = async () => {
    try {
      const report = {
        ...userReport,
        duration: duration,
        durationType: durationType,
        complaintRemark,
        complaintLocation,
        subComplaintRemark,
        impressionRemark,
        examinationRemark,
        treatmentRemark,
        otherSymptomRemark,
        otherSymptomDuration,
        otherSymptomDurationType,
        otherSymptomLocation,
        examinationLocation,
        impressionLocation,
        historyRemark,
        historyDuration,
        historyDurationType,
      };
      const formattedData = formatReportData(report);
      await navigator.clipboard.writeText(formattedData);
      setTextCopied(true);
      setTimeout(() => {
        setTextCopied(false);
      }, 5000);
    } catch (err) {
      console.error("Failed to copy: ", err);
    }
  };

  const mergeWithoutDuplicates = (array1: any, array2: any) => {
    const set = new Set(array1.map((item: any) => item.description));
    const filteredArray2 = array2.filter(
      (item: any) => !set.has(item.description)
    );
    return [...array1, ...filteredArray2];
  };

  const mergedData = mergeWithoutDuplicates(data, userReport.examinations).sort(
    (a: any, b: any) => {
      const vitalsOrder = [
        "Temperature",
        "Blood Pressure",
        "Heart Rate",
        "Height & Weight",
        "Body Mass Index",
      ];
      const aIsVital = vitalsOrder.includes(a.description);
      const bIsVital = vitalsOrder.includes(b.description);
      if (aIsVital && !bIsVital) return -1;
      if (!aIsVital && bIsVital) return 1;
      return 0;
    }
  );

  const handleErase = () => {
    setReport({
      system: null,
      complaints: [],
      otherSymptoms: [],
      history: [],
      examinations: [],
      impressions: [],
      treatment_plans: [],
    });

    setComplaintRemark("");
    setImpressionRemark("");
    setExaminationRemark("");
    setTreatmentRemark("");
    setOtherSymptomRemark("");
    setOtherSymptomDuration(null);
    setOtherSymptomDurationType("");
    setHistoryRemark("");
    setHistoryDuration(null);
    setHistoryDurationType("");
    setDuration(null);
    setDurationType("");
    setData([]);
    setPage(1);
    setOtherSymptomLocation([]);
    setComplaintLocation([]);
    setExaminationLocation?.([]);
    setImpressionLocation?.([]);
    if (resetSelectedOptions) {
      resetSelectedOptions();
    }
  };

  useEffect(() => {
    console.log(complaintLocation, otherSymptomLocation, examinationLocation, impressionLocation);
  }, [complaintLocation, otherSymptomLocation, examinationLocation, impressionLocation]);

  return (
    <>
      <h1
        className="mb-5 w-[100%] text-left font-semibold text-textPrimary sm:w-[70%]"
        style={{ fontSize: 24 }}
      >
        Medical Note
      </h1>
      <hr className="border-borderPrimary" />

      <div className="mt-3" style={{ height: "80%", overflowY: "auto" }}>
        <>
          <p className="w-[100%] text-[14px] text-textPrimary sm:w-[100%]">
            {userReport.complaints && userReport.complaints.length > 0 && (
              <h1 className="mt-3 w-[100%] text-left text-[20px] font-semibold text-textPrimary sm:w-[100%]">
                S:
              </h1>
            )}
            {userReport.complaints?.map((complaint, index) => {
              return (
                <React.Fragment key={index}>
                  {/* {index === 0 ? "S: " : ""} */}
                  <span className="font-medium">{complaint.description}</span>
                  {(complaint as any).scroll_downs &&
                    (complaint as any).scroll_downs.length > 0 && (
                      <>
                        {" "}
                        {(complaint as any).scroll_downs.map(
                          (scroll_down: any, index: any) => (
                            <React.Fragment key={index}>
                              {scroll_down}
                              {index <
                              (complaint as any).scroll_downs.length - 1
                                ? ", "
                                : " "}
                            </React.Fragment>
                          )
                        )}{" "}
                      </>
                    )}
                  {(duration !== null ||
                    (durationType &&
                      durationType !== "Seconds" &&
                      durationType !== "")) && (
                    <span>
                      {` since ${duration ? duration + " " : ""}${
                        duration
                          ? duration != 1
                            ? durationType.slice(-1) === "s"
                              ? durationType
                              : durationType + "s"
                            : durationType.slice(-1) === "s"
                            ? durationType.slice(0, -1)
                            : durationType
                          : durationType.toLowerCase()
                      }`}
                      <br />
                    </span>
                  )}
                  {!(
                    (duration !== null && !isNaN(duration)) ||
                    (durationType &&
                      durationType !== "Seconds" &&
                      durationType !== "")
                  ) && <br />}
                </React.Fragment>
              );
            })}
            {Array.isArray(complaintLocation) &&
              complaintLocation.length >= 1 &&
              Boolean(formatLocationsText(complaintLocation)) && (
                <>
                  <span className="font-medium">
                    Location: {formatLocationsText(complaintLocation)}
                  </span>
                  <br />
                </>
              )}
            {complaintRemark && <div>{complaintRemark}</div>}
          </p>
        </>

        {/* {userReport.subComplaints && userReport.subComplaints.length > 0 && (
          <div className="mb-4">
            <h2 className="text-black text-[18px] font-semibold mb-2">Associated Symptoms:</h2>
            <p className="text-black text-[14px]">
              {userReport.subComplaints?.map((sub_complaint, index) => {
                const isLast = index === userReport.subComplaints.length - 1;
                const separator = isLast
                  ? ""
                  : index === userReport.subComplaints.length - 2
                    ? " and "
                    : ", ";
                return (
                  <React.Fragment key={index}>
                    {index === 0 ? "Patient also has " : ""}
                    <span className="font-medium">{sub_complaint.description}</span>
                    {sub_complaint.scroll_downs && sub_complaint.scroll_downs.length > 0 && (
                      <>
                        {" "}
                        {sub_complaint.scroll_downs.map((scroll_down, idx) => (
                          <React.Fragment key={idx}>
                            {scroll_down}
                            {idx < sub_complaint.scroll_downs.length - 1 ? ", " : ""}
                          </React.Fragment>
                        ))}
                        {""}
                      </>
                    )}
                    {separator}
                  </React.Fragment>
                );
              })}
              {subComplaintRemark && (
                <div className="mt-2">
                  {subComplaintRemark}
                </div>
              )}
            </p>
          </div>
        )} */}

        {
          // userReport.otherSymptoms && userReport.otherSymptoms.length > 0 &&
          <>
            {/* <h1 className="text-black mt-3 w-[100%] text-left text-[20px] font-semibold sm:w-[100%]">
              Other Symptoms:
            </h1> */}
            <p className="text-black w-[100%] text-[14px] sm:w-[100%]">
              {userReport.otherSymptoms?.map((os, index) => {
                return (
                  <React.Fragment>
                    {index == 0 ? null : <br />}
                    {os.description + " "}
                    {(os as any).scroll_downs &&
                      (os as any).scroll_downs.length > 0 && (
                        <>
                          {(os as any).scroll_downs.map(
                            (scroll_down: any, index: any) => (
                              <React.Fragment key={index}>
                                {scroll_down}
                                {index < (os as any).scroll_downs.length - 1
                                  ? ", "
                                  : " "}
                              </React.Fragment>
                            )
                          )}
                        </>
                      )}
                  </React.Fragment>
                );
              })}
              {userReport.otherSymptoms &&
                userReport.otherSymptoms.length > 0 &&
                (otherSymptomDuration !== null ||
                  (otherSymptomDurationType &&
                    otherSymptomDurationType !== "Seconds" &&
                    otherSymptomDurationType !== "")) && (
                  <>
                    <br />
                    <span>
                      {` since ${
                        otherSymptomDuration ? otherSymptomDuration + " " : ""
                      }${
                        otherSymptomDuration
                          ? otherSymptomDuration != 1
                            ? otherSymptomDurationType.slice(-1) === "s"
                              ? otherSymptomDurationType
                              : otherSymptomDurationType + "s"
                            : otherSymptomDurationType.slice(-1) === "s"
                            ? otherSymptomDurationType.slice(0, -1)
                            : otherSymptomDurationType
                          : otherSymptomDurationType.toLowerCase()
                      }`}
                    </span>
                  </>
                )}
              {userReport.otherSymptoms &&
                userReport.otherSymptoms.length > 0 &&
                Array.isArray(otherSymptomLocation) &&
                otherSymptomLocation.length >= 1 &&
                Boolean(formatLocationsText(otherSymptomLocation)) && (
                  <>
                    <br />
                    <span className="font-medium">
                      Location: {formatLocationsText(otherSymptomLocation)}
                    </span>
                  </>
                )}

              {otherSymptomRemark && (
                <>
                  {/* <strong>Remarks</strong> : */}
                  {userReport.otherSymptoms &&
                    userReport.otherSymptoms.length > 0 && <br />}
                  <React.Fragment>{otherSymptomRemark}</React.Fragment>
                </>
              )}
            </p>
          </>
        }

        {
          <>
            {((userReport.history && userReport.history.length > 0) ||
              historyRemark) && (
              <h1 className="text-black mt-3 w-[100%] text-left text-[20px] font-semibold sm:w-[100%]">
                H:{" "}
              </h1>
            )}

            <p className="text-black w-[100%] text-[14px] sm:w-[100%]">
              {userReport.history &&
                userReport.history.length > 0 &&
                userReport.history?.map((os, index) => {
                  return (
                    <React.Fragment>
                      {os.description + " "}
                      {(os as any).scroll_downs &&
                        (os as any).scroll_downs.length > 0 && (
                          <>
                            {(os as any).scroll_downs.map(
                              (scroll_down: any, index: any) => (
                                <React.Fragment key={index}>
                                  {scroll_down}
                                  {index < (os as any).scroll_downs.length - 1
                                    ? ", "
                                    : ""}
                                </React.Fragment>
                              )
                            )}
                          </>
                        )}
                      <br />
                    </React.Fragment>
                  );
                })}
              {userReport.history &&
                userReport.history.length > 0 &&
                (historyDuration !== null ||
                  (historyDurationType &&
                    historyDurationType !== "Seconds" &&
                    historyDurationType !== "")) && (
                  <span>
                    {` since ${historyDuration ? historyDuration + " " : ""}${
                      historyDuration
                        ? historyDuration != 1
                          ? historyDurationType.slice(-1) === "s"
                            ? historyDurationType
                            : historyDurationType + "s"
                          : historyDurationType.slice(-1) === "s"
                          ? historyDurationType.slice(0, -1)
                          : historyDurationType
                        : historyDurationType.toLowerCase()
                    }`}
                    <br />
                  </span>
                )}
              {historyRemark && (
                <>
                  {/* <strong>Remarks</strong> : */}
                  <React.Fragment>{historyRemark}</React.Fragment>
                </>
              )}
            </p>
          </>
        }

        {
          <>
            {((mergedData && mergedData.length > 0) || examinationRemark) && (
              <h1 className="text-black mt-3 w-[100%] text-left text-[20px] font-semibold sm:w-[100%]">
                O/E:
              </h1>
            )}

            <p className="text-black w-[100%] text-[14px] leading-tight sm:w-[100%]">
              {mergedData.map((item, i) => {
                const isStaticExamination =
                  item.description === "Temperature" ||
                  item.description === "Blood Pressure" ||
                  item.description === "Heart Rate" ||
                  item.description === "Height & Weight" ||
                  item.description === "Body Mass Index";

                const hasConditions =
                  (item as any).scroll_downs &&
                  (item as any).scroll_downs.length > 0;

                let weightKG,
                  weightPounds,
                  heightFeets,
                  heightInches,
                  heightCM,
                  tempUnit;

                if (item.description === "Height & Weight") {
                  weightKG = item.value.find(
                    (x: any) => x.unitValue === "Kilos"
                  );
                  weightPounds = item.value.find(
                    (x: any) => x.unitValue === "Pounds"
                  );
                  heightCM = item.value.find(
                    (x: any) => x.unitValue === "Centimeters"
                  );
                  heightFeets = item.value.find(
                    (x: any) => x.unitValue === "Feets"
                  );
                  heightInches = item.value.find(
                    (x: any) => x.unitValue === "Inches"
                  );
                }

                if (
                  item.description === "Temperature" &&
                  item.value?.[0]?.unitValue
                ) {
                  tempUnit =
                    item.value[0].unitValue === "Fahrenheit" ? "F°" : "C°";
                }

                return (
                  <Box key={i} display="block" mb={0.5}>
                    {/* Height & Weight (KG) */}
                    {weightKG && (
                      <span>
                        Height: {heightCM?.inputValue} centimeters, Weight:{" "}
                        {weightKG?.inputValue} kilos
                      </span>
                    )}

                    {/* Height & Weight (Pounds) */}
                    {weightPounds && (
                      <span>
                        Height: {heightFeets?.inputValue} feets{" "}
                        {heightInches?.inputValue} inches, Weight:{" "}
                        {weightPounds?.inputValue} pounds
                      </span>
                    )}

                    {/* Other examinations */}
                    {!weightKG && !weightPounds && (
                      <span>
                        {item.description}
                        {isStaticExamination ? ": " : " "}
                        {item.value?.[0]?.inputValue}
                        {item.description === "Temperature"
                          ? tempUnit
                          : item.value?.[0]?.unitValue
                          ? ` ${item.value[0].unitValue}`
                          : ""}
                      </span>
                    )}

                    {/* Scroll downs (SAME LINE) */}
                    {hasConditions && (
                      <span>
                        {" "}
                        {(item as any).scroll_downs
                          .map((sd: any) => sd.description)
                          .join(", ")}
                      </span>
                    )}
                  </Box>
                );
              })}

              {mergedData &&
                mergedData.length > 0 &&
                Array.isArray(examinationLocation) &&
                examinationLocation.length >= 1 &&
                Boolean(formatLocationsText(examinationLocation)) && (
                  <>
                    <span className="font-medium">
                      Location: {formatLocationsText(examinationLocation)}
                    </span>
                    <br />
                  </>
                )}

              {examinationRemark && <div>{examinationRemark}</div>}
            </p>
          </>
        }

        {
          <>
            {((userReport.impressions && userReport.impressions.length > 0) ||
              impressionRemark ||
              (Array.isArray(impressionLocation) &&
                impressionLocation.length >= 1)) && (
              <h1 className="text-black mt-3 w-[100%] text-left text-[20px] font-semibold sm:w-[100%]">
                A:
              </h1>
            )}

            <p className="text-black w-[100%] text-[14px] sm:w-[100%]">
              {userReport.impressions?.map((impression) => {
                return (
                  <React.Fragment>
                    {impression.description + " "}
                    {(impression as any).scroll_downs &&
                      (impression as any).scroll_downs.length > 0 && (
                        <>
                          {(impression as any).scroll_downs.map(
                            (scroll_down: any, index: any) => (
                              <React.Fragment key={index}>
                                {scroll_down}
                                {index <
                                (impression as any).scroll_downs.length - 1
                                  ? ", "
                                  : ""}
                              </React.Fragment>
                            )
                          )}
                        </>
                      )}
                    <br />
                  </React.Fragment>
                );
              })}

              {Array.isArray(impressionLocation) &&
                impressionLocation.length >= 1 &&
                Boolean(formatLocationsText(impressionLocation)) && (
                  <>
                    <span className="font-medium">
                      Location: {formatLocationsText(impressionLocation)}
                    </span>
                    <br />
                  </>
                )}

              {impressionRemark && (
                <>
                  {/* <strong>Remarks</strong> : */}
                  <React.Fragment>{impressionRemark}</React.Fragment>
                </>
              )}
            </p>
          </>
        }

        {
          <>
            {((userReport.treatment_plans &&
              userReport.treatment_plans.length > 0) ||
              treatmentRemark) && (
              <h1 className="text-black mt-3 w-[100%] text-left text-[20px] font-semibold sm:w-[100%]">
                P:
              </h1>
            )}

            <p className="text-black w-[100%] text-[14px] sm:w-[100%]">
              {userReport.treatment_plans?.map((treatment) => {
                return (
                  <React.Fragment>
                    {treatment.description + " "}
                    {(treatment as any).scroll_downs &&
                      (treatment as any).scroll_downs.length > 0 && (
                        <>
                          <br />
                          {(treatment as any).scroll_downs.map(
                            (scroll_down: any, index: any) => (
                              <React.Fragment key={index}>
                                - {scroll_down}
                                {index <
                                (treatment as any).scroll_downs.length - 1 ? (
                                  <br />
                                ) : (
                                  ""
                                )}
                              </React.Fragment>
                            )
                          )}
                          {/* <br /> */}
                        </>
                      )}
                    <br />
                  </React.Fragment>
                );
              })}
              {treatmentRemark && (
                <>
                  {/* <br /> */}
                  {/* <strong>Remarks</strong> : */}
                  <React.Fragment>{treatmentRemark}</React.Fragment>
                </>
              )}
            </p>
          </>
        }
      </div>
      <div className="flex items-center gap-5">
        <button
          onClick={handleCopyToClipboard}
          className={`${
            textCopied
              ? "items-left w-fit !bg-copyBtnSurface !text-white hover:!bg-copyBtnSurface/80 active:!bg-copyBtnSurface/70"
              : "w-40 items-center justify-center bg-surfaceSecondary text-brand-500 hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
          } linear mr-3 mt-3 flex rounded-lg p-3 text-sm font-bold transition duration-200 hover:cursor-pointer`}
        >
          {textCopied ? (
            <>
              Copied to Clipboard{" "}
              <MdCheck style={{ width: 20, height: "auto" }} className="ml-3" />
            </>
          ) : (
            "Copy to Clipboard"
          )}
        </button>
        <button
          onClick={handleErase}
          className="linear mr-3 mt-3 flex w-40 items-center justify-center rounded-lg bg-surfaceSecondary p-3 text-sm font-bold text-brand-500 transition duration-200 hover:cursor-pointer hover:bg-surfaceSecondary/80 active:bg-surfaceSecondary/70"
        >
          Erase Now
        </button>
      </div>
    </>
  );
};

export default WizardReport;
